import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="confirm-delete"
// Toggles between an edit form and a delete confirmation panel
// Both panels are stacked in a CSS grid so they share the same height
export default class extends Controller {
  static targets = ["editPanel", "deletePanel", "input", "submit"]
  static values = { name: String }

  showDelete() {
    this.editPanelTarget.classList.add("invisible")
    this.deletePanelTarget.classList.remove("invisible")
    this.inputTarget.focus()
  }

  showEdit() {
    this.deletePanelTarget.classList.add("invisible")
    this.inputTarget.value = ""
    this.submitTarget.disabled = true
    this.editPanelTarget.classList.remove("invisible")
  }

  validate() {
    const matches = this.inputTarget.value === this.nameValue
    this.submitTarget.disabled = !matches
  }
}
